import { z } from 'zod';
import { MAX_NEW_CONTACTS, MAX_NEW_CONTACTS_MESSAGE } from './constraints.js';
import { createContactInputSchema } from './create-input.js';
import { refineSinglePrimaryContact } from './refine-single-primary-contact.js';
/** The contacts a createCustomer or createVendor call carries, at most one of them primary. */
export const newContactsInputSchema = z
    .array(createContactInputSchema)
    .max(MAX_NEW_CONTACTS, MAX_NEW_CONTACTS_MESSAGE)
    .superRefine(refineSinglePrimaryContact);
//# sourceMappingURL=new-contacts-input.js.map